const registerFormTooltips = {
  stockreport: {
    stockreport_code: 'Enter the stock report code.',
    stockreport_name: 'Enter the stock report name.',
    destination: 'Select the destination location.',
    phone_number: 'Enter the PIC phone number.',
    address: 'Enter the location address.',
    pic: 'Enter the PIC name.',
    email: 'Enter the PIC email.',
    pic_delivery: 'Enter the delivery PIC name.',
    email_delivery: 'Enter the delivery PIC email.',
  },
  inventory: {
    inventory_code: 'Enter the inventory/warehouse code.',
    inventory_name: 'Enter the inventory/warehouse name.',
    destination: 'Select the delivery destination.',
    phone_number: 'Enter the warehouse PIC phone number.',
    address: 'Enter the warehouse address.',
    pic: 'Enter the warehouse PIC name.',
    email: 'Enter the warehouse PIC email.',
    pic_delivery: 'Enter the delivery/receiving PIC name.',
    email_delivery: 'Enter the delivery PIC email.',
  },
  ewsreport: {
    ewsreport_code: 'Enter the EWS report code.',
    ewsreport_name: 'Enter the EWS report name.',
    destination: 'Select the report destination.',
    phone_number: 'Enter the contact number for alerts.',
    address: 'Enter the destination address.',
    pic: 'Enter the main PIC name.',
    email: 'Enter the PIC email.',
    pic_delivery: 'Enter the document delivery PIC.',
    email_delivery: 'Enter the delivery PIC email.',
  },
  fourmreport: {
    fourmreport_code: 'Enter the 4M report code.',
    fourmreport_name: 'Enter the 4M report name.',
    destination: 'Select the report destination.',
    phone_number: 'Enter the PIC contact number.',
    address: 'Enter the destination address.',
    pic: 'Enter the main PIC name.',
    email: 'Enter the PIC email.',
    pic_delivery: 'Enter the delivery PIC name.',
    email_delivery: 'Enter the delivery PIC email.',
  },
  monitoring: {
    monitoringname: 'Create a unique monitoring ID.',
    email: 'Enter an email for login and notifications.',
    fullname: 'Enter the full name.',
    role: 'Select the user access role.',
    vendor_code: 'Fill only if linked to a vendor.',
    password: 'Use at least 8 characters (letters & numbers).',
    password_confirmation: 'Re-enter the password.',
  },
  vendor: {
    vendor_code: 'Enter the official vendor code.',
    vendor_code_locked: 'Cannot be changed during edit.',
    vendor_selector: 'Select the vendor.',
    vendor_name: 'Enter the vendor company name.',
    vendor_alias: 'Enter short/alias name (optional).',
    destination: 'Select the main delivery destination.',
    phone_number: 'Enter the vendor PIC phone number.',
    address: 'Enter the vendor address.',
    pic: 'Enter the vendor PIC name.',
    email: 'Enter the vendor PIC email.',
    pic_delivery: 'Enter the delivery PIC name.',
    email_delivery: 'Enter the delivery PIC email.',
    fg: 'Fill the default FG percentage.',
    wip: 'Fill the default WIP percentage.',
    apply_to_materials: 'Check to apply FG & WIP to all vendor materials.',
  },
  material: {
    vendor_code: 'Select the material vendor.',
    vendor_code_locked: 'Cannot be changed during edit.',
    matl_code: 'Enter the material code (SAP/ERP).',
    matl_code_locked: 'Cannot be changed during edit.',
    item_no: 'Enter a unique item number.',
    sebango: 'Enter the Sebango code.',
    part_name: 'Enter the complete part name.',
    project: 'Enter the project/customer.',
    qty_kbn: 'Enter the quantity per kanban/pack.',
    unit: 'Select the unit (pcs, set, etc.).',
    part_level: 'Enter BOM part level (1=top).',
    fg: 'Fill the default FG percentage.',
    wip: 'Fill the default WIP percentage.',
  },
  rolepermission: {
    name: 'Enter a unique role permission name.',
    email: 'Enter the related email contact.',
    first_name: 'Enter the first name.',
    last_name: 'Enter the last name (optional).',
    organization: 'Enter the organization/unit name.',
    phone: 'Enter an active phone number.',
    role_id: 'Select the access role.',
    status: 'Set the status (active/inactive).',
    password: 'Use at least 8 characters (letters & numbers).',
    password_confirmation: 'Re-enter the password.',
  },
  mastergrouping: {
    group_name: 'Enter the menu group name.',
    description: 'Describe the menu group (optional).',
    order: 'Set display order (lower shows higher).',
    status: 'Set the status (active/inactive).',
  },
  masterGrouping: {
    name: 'Enter the grouping name.',
    email: 'Enter the grouping PIC email.',
    first_name: 'Enter the PIC first name.',
    last_name: 'Enter the PIC last name (optional).',
    organization: 'Enter the organization/division.',
    phone: 'Enter a contact phone number.',
    role_id: 'Select a role for access.',
    password: 'Use at least 8 characters.',
    password_confirmation: 'Re-enter the password.',
    status: 'Set active status.',
  },
  product: {
    name: 'Enter the product name.',
    email: 'Enter the product PIC email.',
    first_name: 'Enter the PIC first name.',
    last_name: 'Enter the PIC last name (optional).',
    organization: 'Enter the related organization/brand.',
    phone: 'Enter the PIC phone number.',
    role_id: 'Select the access role.',
    password: 'Use at least 8 characters.',
    password_confirmation: 'Re-enter the password.',
    status: 'Set active status.',
  },
  user: {
    username: 'Enter a unique username (no spaces).',
    email: 'Enter the user email.',
    fullname: 'Enter the full name.',
    role: 'Select the access role.',
    vendor_code: 'Fill only if the user represents a vendor.',
    pic_plant: 'Select the plant location for this user (optional).',
    pin: 'Enter a unique PIN number.',
    password: 'Use at least 8 characters.',
    password_confirmation: 'Re-enter the password.',
  },
  role: {
    role_id: 'Enter a unique ID (lowercase, no spaces).',
    role_id_locked: 'Cannot be changed during edit.',
    role_name: 'Enter the role display name.',
    description: 'Describe the role (optional).',
    is_active: 'Set role status to active.',
  },
  forecast: {
    forecastname: 'Enter a unique forecast account name.',
    email: 'Enter the forecast account email.',
    fullname: 'Enter the full name.',
    role: 'Select the access role.',
    vendor_code: 'Fill if linked to a vendor.',
    password: 'Use at least 8 characters.',
    password_confirmation: 'Re-enter the password.',
  },
  dashboard: {
    dashboardname: 'Enter a short, recognizable dashboard name.',
    email: 'Enter the dashboard PIC email.',
    fullname: 'Enter the full name.',
    role: 'Select the access role.',
    vendor_code: 'Leave blank unless vendor-specific.',
    password: 'Use at least 8 characters.',
    password_confirmation: 'Re-enter the password.',
  },
  business: {
    name: 'Enter the business name.',
    industry: 'Select the industry type.',
    logo_path: 'Enter the logo URL/path.',
    status: 'Set active status.',
  },
  forecastsupplier: {
    forecastsuppliername: 'Enter a recognizable supplier name.',
    email: 'Enter the supplier email.',
    fullname: 'Enter the full name.',
    role: 'Select the access role.',
    vendor_code: 'Fill if linked to a vendor.',
    password: 'Use at least 8 characters.',
    password_confirmation: 'Re-enter the password.',
  },
  system: {
    config_type: 'Use snake_case (e.g., commodity_options).',
    config_key: 'Enter a unique config key.',
    config_key_locked: 'Cannot be changed during edit.',
    config_value: 'Enter a config value (number/string/JSON).',
    description: 'Describe the config (optional).',
    is_active: 'Disable if not used.',
  },
  emailSchedule: {
    schedule_name: 'Enter a unique schedule name.',
    schedule_type: 'Select schedule frequency.',
    every_minutes: 'Enter minute interval.',
    every_hours: 'Enter hour interval.',
    time_of_day: 'Enter execution time (24h).',
    cron: 'Fill only if using CRON.',
    template_id: 'Select an email template.',
    recipient_id: 'Select a recipient group.',
    schedule_days_weekly: 'Select days of the week.',
    schedule_dates_monthly: 'Select dates of the month.',
    schedule_days_custom: 'Limit cron to specific days (optional).',
    status: 'Set active/inactive status.',
    description: 'Add a schedule note (optional).',
    api_url: 'Enter API endpoint URL.',
    api_method: 'Select HTTP method.',
    api_params: 'Enter request parameters (JSON).',
    api_headers: 'Enter API headers if needed.',
    api_toggle_info: 'Enable API fetch before sending email.',
  },
  emailTemplate: {
    template_name: 'Use lowercase/underscore name.',
    template_type: 'Select template category.',
    description: 'Describe template usage.',
    subject: 'Enter email subject (supports {{variable}}).',
    body: 'Paste full HTML (supports {{variable}}).',
    preview: 'Preview Email',
    variables_info: 'Variables available in {{variable_name}} format.',
    variables_input: 'Enter JSON list of variables.',
    is_active: 'Disable if not in use.',
  },
  emailRecipient: {
    recipient_name: 'Enter the recipient group name.',
    email_address: 'Type emails, press Enter/comma to add multiple.',
    description: 'Add a note (optional).',
    is_active: 'Disable if group should not receive emails.',
  },
  menuMaster: {
    menu_id: 'Enter a unique menu ID (no spaces).',
    menu_id_locked: 'Cannot be changed during edit.',
    menu_name: 'Enter the sidebar menu name.',
    menu_path: 'Enter URL path starting with /.',
    menu_icon: 'Enter icon name (optional).',
    menu_order: 'Enter menu order (lower = higher).',
    parent_menu_id: 'Select parent menu if submenu.',
    description: 'Add a description (optional).',
    is_active: 'Disable to hide menu.',
  },
};

const resolveTooltip = (formKey, fieldKey) => {
  if (!formKey || !fieldKey) {
    return '';
  }

  return registerFormTooltips[formKey]?.[fieldKey] || '';
};

export const getRegisterFormTooltip = (formKey, fieldKey, fallback = '') => {
  return resolveTooltip(formKey, fieldKey) || fallback;
};

export const getRegisterFormTooltipByKey = (key, fallback = '') => {
  if (!key) return fallback;

  const [formKey, fieldKey] = key.split('.');
  return getRegisterFormTooltip(formKey, fieldKey, fallback);
};

export default registerFormTooltips;
